import {GridApi} from 'ag-grid-community';

import {filterTechnicalArray} from './filterTechnicalArray';
import {getPresetStates} from './getPresetStates';
import {isPartialColumnFetchingEnabled} from './isPartialColumnFetchingEnabled';

/**
 * Retrieves a list of column keys based on the provided `GridApi`, predefined columns, and grid code.
 *
 * This function checks if partial column fetching is enabled for the given grid code and ensures
 * the `GridApi` instance is not destroyed before proceeding. It combines visible columns from the
 * grid's preset states with the predefined columns, removing duplicates.
 *
 * @param api - The `GridApi` instance used to interact with the grid.
 * @param predefinedColumns - A readonly array of predefined column keys to include in the result.
 * @param gridCode - A string representing the grid code, used to determine if partial column fetching is enabled.
 * @returns An array of unique column keys, combining visible grid columns and predefined columns.
 */
export const getColumnsParam = (
  api: GridApi,
  predefinedColumns: readonly string[],
  gridCode: string
) => {
  if (!isPartialColumnFetchingEnabled(gridCode)) {
    return [];
  }

  if (api.isDestroyed()) {
    return [];
  }

  const gridColumns = filterTechnicalArray(getPresetStates(api))
    .filter((item) => item.visible)
    .map((state) => state.columnKey);

  const columns = new Set(gridColumns);
  predefinedColumns.forEach((item) => {
    if (!columns.has(item)) {
      columns.add(item);
    }
  });

  return Array.from(columns);
};
